import React from 'react';
import { Grid, TextField, Typography, Box, MenuItem, FormControl, InputLabel, Select, FormHelperText } from '@mui/material';
import { surgeonOptions, anesthetistOptions, assistantOptions, anestheticAssistantOptions } from '../../constants/options';

const StaffSection = ({ formData, handleChange, errors }) => {
  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6" sx={{ color: '#008080', mb: 2, fontWeight: 'bold' }}>
        Step 5: Surgical & Anesthesia Team
      </Typography>
      
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth size="small" error={!!errors.name_of_surgeon} required sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
            <InputLabel>Name of Surgeon</InputLabel>
            <Select
              name="name_of_surgeon"
              value={formData.name_of_surgeon || ''}
              label="Name of Surgeon"
              onChange={handleChange}
            >
              {surgeonOptions.map(opt => <MenuItem key={opt} value={opt}>{opt}</MenuItem>)}
            </Select>
            {errors.name_of_surgeon && <FormHelperText>{errors.name_of_surgeon}</FormHelperText>}
          </FormControl>
        </Grid>
        
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth size="small">
            <InputLabel>Name of Assistant</InputLabel>
            <Select
              name="name_of_assistant"
              value={formData.name_of_assistant || ''}
              label="Name of Assistant"
              onChange={handleChange}
            >
              {assistantOptions.map(opt => <MenuItem key={opt} value={opt}>{opt}</MenuItem>)}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6}>
          <FormControl fullWidth size="small" error={!!errors.name_of_anesthetist} required sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
            <InputLabel>Name of Anesthetist</InputLabel>
            <Select
              name="name_of_anesthetist"
              value={formData.name_of_anesthetist || ''}
              label="Name of Anesthetist"
              onChange={handleChange}
            >
              {anesthetistOptions.map(opt => <MenuItem key={opt} value={opt}>{opt}</MenuItem>)}
            </Select>
            {errors.name_of_anesthetist && <FormHelperText>{errors.name_of_anesthetist}</FormHelperText>}
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6}>
          <FormControl fullWidth size="small">
            <InputLabel>Name of Assistant Anesthesia</InputLabel>
            <Select
              name="name_of_assistant_anesthesia"
              value={formData.name_of_assistant_anesthesia || ''}
              label="Name of Assistant Anesthesia"
              onChange={handleChange}
            >
              {anestheticAssistantOptions.map(opt => <MenuItem key={opt} value={opt}>{opt}</MenuItem>)}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </Box>
  );
};

export default StaffSection;
